import {
  normalizeContactEmails,
  resolveContactEmailsFromData,
} from '../platform/contactEmails';
import {
  normalizeContactPhones,
  resolveContactPhonesFromData,
} from '../platform/contactPhones';

class Contact {
  constructor({
    id,
    name,
    emails,
    phones,
    unit,
    unitName,
    listGroupId,
    uid,
    createdAt,
  }) {
    this.id = id || null;
    this.name = name || '';
    this.emails = normalizeContactEmails(emails || []);
    this.phones = normalizeContactPhones(phones || []);
    this.unit = unit || 'general';
    this.unitName = unitName || 'Splošno';
    this.listGroupId = listGroupId || '';
    this.uid = uid || '';
    this.createdAt = createdAt || new Date();
  }

  toFirestore() {
    return {
      name: this.name,
      emails: this.emails,
      phones: this.phones,
      unit: this.unit,
      unitName: this.unitName,
      listGroupId: this.listGroupId || '',
      uid: this.uid,
      createdAt: this.createdAt,
    };
  }

  static fromFirestore(snapshot) {
    const data = snapshot.data();
    return new Contact({
      id: snapshot.id,
      name: data.name,
      emails: resolveContactEmailsFromData(data),
      phones: resolveContactPhonesFromData(data),
      unit: data.unit || 'general',
      unitName: data.unitName || 'Splošno',
      listGroupId: data.listGroupId || '',
      uid: data.uid,
      createdAt: data.createdAt ? data.createdAt.toDate() : new Date(),
    });
  }
}

export default Contact;
